import { render } from "./xcIndex.vue?vue&type=template&id=19304ccb&scoped=true"
import script from "./xcIndex.vue?vue&type=script&lang=js"
export * from "./xcIndex.vue?vue&type=script&lang=js"

import "./xcIndex.vue?vue&type=style&index=0&id=19304ccb&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19304ccb"]])

export default __exports__